/**
 * LaVillaLogo - Inline logo component to replace "La Villa" text
 * 
 * @param {string} size - 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl'
 * @param {string} className - Additional CSS classes
 * @param {boolean} dark - true for light backgrounds (dark logo), false for dark backgrounds (white logo)
 */
export default function LaVillaLogo({ size = 'md', className = '', dark = true }) {
  const sizeClasses = {
    'xs': 'h-3',
    'sm': 'h-4',
    'md': 'h-5',
    'lg': 'h-6',
    'xl': 'h-8',
    '2xl': 'h-10',
    '3xl': 'h-12',
    '4xl': 'h-16',
    '5xl': 'h-20',
  };

  const heightClass = sizeClasses[size] || sizeClasses['md'];
  
  // Use dark logo with multiply blend for light backgrounds
  // Use white logo (PNG with transparency) for dark backgrounds
  if (dark) {
    return (
      <img
        src="/images/la-villa-logo.jpg"
        alt="La Villa"
        className={`inline-block w-auto ${heightClass} ${className}`}
        style={{ mixBlendMode: 'multiply' }}
      />
    );
  }
  
  // For dark backgrounds - use the white PNG logo
  return (
    <img
      src="/images/logo-new-white.png"
      alt="La Villa"
      className={`inline-block w-auto ${heightClass} ${className}`}
    />
  );
}
